<template>
  <component :is="isMobile ? 'sliding-modal' : 'section'" v-bind="rootProps">
    <component :is="isMobile ? 'vk-modal-body' : 'div'" v-bind="bodyProps">
      <component
          v-if="$slots.header"
          :is="isMobile ? 'vk-modal-header' : 'div'"
          v-bind="headerProps">
        <slot name="header" />
      </component>
      <slot />
    </component>
  </component>
</template>

<script>
import SlidingModal from '@/views/Dashboard/components/SlidingModal';

export default {
  name: 'dashboard-panel',
  components: {
    SlidingModal,
  },
  props: {
    isOpen: Boolean,
    isMobile: Boolean,
  },
  computed: {
    rootProps () {
      return this.isMobile
        ? {
          isOpen: this.isOpen,
          transitionName: 'SLIDE-RIGHT',
          backdropClass: 'bg-transparent',
        }
        : {
          class: 'DASHBOARD-PANEL',
        };
    },
    bodyProps () {
      return this.isMobile
        ? {
          slot: 'body',
          class: 'SHADOW',
        }
        : {
          class: 'DASHBOARD-PANEL-CONTENT',
        };
    },
    headerProps () {
      return this.isMobile
        ? {
          class: 'd-flex flex-0-0 bd-b-gray30',
        }
        : {
          class: 'd-flex flex-0-0 bg-gray20 bd-b-gray30',
        };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .DASHBOARD-PANEL {
    @include margin(1, 2 1, $lg: 4 1);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    border-radius: $unit/2;
    box-shadow: 0 0 4px rgba(black, 0.25);
    border: 1px solid $color-gray30;
    background-color: white;
  }

  .DASHBOARD-PANEL-CONTENT {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }

  .SHADOW {
    @include responsive(box-shadow, 0 0 10px rgba(black, 0.2), $md: none);
  }
</style>
